import { create } from 'zustand';

type Toast = {
  id: string;
  tone: 'success' | 'error' | 'info';
  title: string;
  body?: string;
};

type UIState = {
  toasts: Toast[];
  pushToast: (t: Omit<Toast, 'id'>) => void;
  dismissToast: (id: string) => void;
};

export const uiStore = create<UIState>((set) => ({
  toasts: [],
  pushToast: (t) =>
    set((s) => ({
      toasts: [
        ...s.toasts,
        { ...t, id: crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2) },
      ],
    })),
  dismissToast: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));

export const useUiStore = uiStore;

// Helper "toast.success/error/info" để gọi từ component
export const toast = {
  success: (title: string, body?: string) =>
    uiStore.getState().pushToast({ tone: 'success', title, body }),
  error: (title: string, body?: string) =>
    uiStore.getState().pushToast({ tone: 'error', title, body }),
  info: (title: string, body?: string) =>
    uiStore.getState().pushToast({ tone: 'info', title, body }),
};
